import create from "zustand";
import { persist } from "zustand/middleware"

// Bug real (auditoría 2026-08-16): `team` se calculaba UNA sola vez acá, al
// momento en que se importa este módulo (Consumers.js -> App.js, que puede
// evaluarse ANTES de que la navegación post-login entre a una URL
// /teams/:id/...). Si en ese instante daba undefined, el store se creaba en
// la rama `create(callback)` de abajo, SIN persist() -- y quedaba así para
// siempre en esa pestaña: ningún filtro/orden de la HCE se guardaba en
// localStorage esa sesión. Y aunque el team estuviera bien al importar, un
// usuario multi-team que cambia de equipo (navegación client-side, sin
// recargar la página) seguía leyendo/escribiendo la key de storage del
// PRIMER team.
// Fix: se extrae `getTeamStorageKey` (testeable de forma aislada), el store
// SIEMPRE usa persist() (con una key neutra si todavía no hay team
// disponible), y se expone `retargetTeam` para que un componente que sí
// conoce el team de forma reactiva (useTeamID(), ver EHR.js) reapunte el
// storage y rehidrate cuando el team se conoce recién después del import, o
// cambia en caliente. zustand 4.0.0-rc.4 (ver node_modules/zustand/
// middleware/persist.d.ts) no soporta una función para `name` en
// PersistOptions -- por eso el re-key se hace en caliente vía
// `persist.setOptions` + `persist.rehydrate`, no computando `name` de forma
// lazy en las options.
export const getTeamStorageKey = (pathname = window.location.pathname) =>
  pathname.match(/\/teams\/[a-z0-9]+/i)?.[0]?.replace('/teams/', '')

let currentTeam = getTeamStorageKey()

const callback = (set, get) => ({
  sort: 'date:desc',
  filters: {
    showDeletedRecords: false,
    uids: {},
    treatments: { status: { active: true, pending: true, done: false } },
    diagnoses: { status: { chronic: true, pending: true, intercurrence: true } },
  },
  update: payload => set(() => ({ ...payload })),
})

// Bug real (auditoría 2026-08-18, LOOP INFINITO EN PRODUCCIÓN — reportado
// por el usuario en la preview de PR): la key neutra usaba literal
// 'default-ehr-storage' — el mismo nombre que src/config/window.js
// interpreta como basura de una versión vieja de la app (de antes de que
// existieran las keys por team) y limpia con localStorage.clear() +
// location.reload() apenas la ve. Como este store escribe esa key en TODA
// carga sin team todavía conocido (ej. la pantalla de login, antes de
// llegar a /teams/:id/...), quedaban compitiendo: el store la escribe,
// window.js la borra y recarga, el store la vuelve a escribir en la
// recarga, window.js la borra de nuevo... loop infinito que nunca dejaba
// llegar al intercambio de code/token de Auth0. 'no-team' no colisiona con
// ese chequeo de migración.
const useStore = create(persist(callback, {
  name: `${currentTeam || 'no-team'}-ehr-storage`,
  partialize: state => ({
    sort: state.sort,
    filters: state.filters,
  })
}))

export const retargetTeam = teamID => {
  const nextTeam = teamID?.replace(/^teams\//, '')
  if (!nextTeam || nextTeam === currentTeam) return
  currentTeam = nextTeam
  useStore.persist.setOptions({ name: `${currentTeam}-ehr-storage` })
  useStore.persist.rehydrate()
}

export default useStore;
